import React, { Component } from 'react';
import { Form, Input, Icon, Button } from 'antd';

import { hasErrors } from '../../common/utils';

class OTPForm extends Component {
    errorCallBack = () => {
        this.props.form.resetFields();
        this.props.form.validateFields((err, values) => {});
    };
    handleSubmit = async (e) => {
		const { getFieldValue } = this.props.form;
		e.preventDefault();
		const body = {
			code: getFieldValue('otp'),
		};
		this.props.submitCallback(body, this.errorCallBack);
	};
    render() {
        const {
			getFieldDecorator,
			getFieldsError
        } = this.props.form;
        return (
            <Form onSubmit={this.handleSubmit}>
				<Form.Item>
					{getFieldDecorator('otp', {
						rules: [
							{ 
								required: true,
								message: 'Invalid 2FA code'
							}
						]
					})(
						<Input
							prefix={
								<Icon
									type="lock"
									style={{ color: 'rgba(0,0,0,.25)' }}
								/>
							}
							type="number"
							placeholder="Enter 6-digit code"
						/>
					)}
				</Form.Item>
				<Form.Item>
					<Button
						type="primary"
						htmlType="submit"
						disabled={hasErrors(getFieldsError())}
					>
						Submit
					</Button>
				</Form.Item>
			</Form>
        )
    }
}

const WrappedOTPForm = Form.create({ name: 'OTP_FORM' })(OTPForm);

export default WrappedOTPForm;
